import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'text!../views/create-message.html';

const fn = ($filter, $scope, $state, $q, $stateParams, ModalService, ServiceRequestService, ViewModelService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.actionView = ViewModelService.create({
            serviceRequestNumber: $stateParams.serviceRequestNumber
        }, 'cc', 'edge.capabilities.servicerequest.dto.ServiceRequestActionDTO');
        $scope.serviceRequestAction = {
            serviceRequestNumber: $stateParams.serviceRequestNumber
        };

        const serviceRequestPromise = ServiceRequestService.getServiceRequestDetails($stateParams.serviceRequestNumber);
        $q.when(
            serviceRequestPromise,
            (serviceRequest) => {
                $scope.actionView.description.value = serviceRequest.referenceNumber;
            },
            (error) => {
                console.error('service request retrieval failed', error);
            }
        );
    };

    ctrl.updateReferenceNumber = (updateReferenceForm) => {
        updateReferenceForm.submitted = true;

        if ($scope.actionView.aspects.subtreeValid) {
            $scope.updateReferencePromise = ServiceRequestService.updateReferenceNumber($scope.actionView.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {serviceRequestNumber: $scope.actionView.serviceRequestNumber.value});
                },
                (error) => {
                    ModalService.showError(
                        'servicerequest.controllers.UpdateReferenceCtrl.Service Request update failed',
                        $q.when(error)
                    );
                }
            );
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$state', '$q', '$stateParams', 'ModalService', 'servicerequest.ServiceRequestService', 'ViewModelService'];
export default fn;
